// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner-custom[data-v-5b38e865]{display:flex;flex-direction:column;align-items:center;justify-content:center;color:#fff;height:100%;width:100%;position:absolute;top:0;left:0;z-index:152}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
